var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"undo-redo-controls"},[_c('button',{class:{ disabled: !_vm.canUndo },on:{"click":_vm.undo}},[_vm._v("\n    undo\n  ")]),_c('button',{class:{ disabled: !_vm.canRedo },on:{"click":_vm.redo}},[_vm._v("\n    redo\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }